// Weather adapter — bridges weather.ts to the WeatherSnapshot world model type
import { getAtmosphericConditions } from './weather';
import type { WeatherSnapshot } from './world-model';

export async function fetchWeather(lat: number, lng: number): Promise<WeatherSnapshot> {
  const conditions = await getAtmosphericConditions();
  return {
    lat,
    lng,
    tempF: conditions.airTempF,
    windMph: conditions.windSpeedKph * 0.621371,
    precipMm: conditions.precipMm,
    pressureHpa: conditions.pressureHpa,
    pressureTrend: conditions.pressureTrend,
    uvIndex: conditions.uvIndex,
    fetchedAt: new Date().toISOString(),
  };
}
